var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "m8.637 17.228-1.365-1.37a2.067 2.067 0 0 0-1.464-.608H4.782A3.789 3.789 0 0 1 1 11.456V4.794A3.788 3.788 0 0 1 4.782 1h9.717a3.787 3.787 0 0 1 3.781 3.794v6.662a3.788 3.788 0 0 1-3.781 3.794h-1.026c-.549 0-1.076.219-1.464.609l-1.366 1.369a1.414 1.414 0 0 1-2.006 0ZM11.86 8.266H7.42M9.64 10.5V6.036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAdd);
export default __webpack_public_path__ + "static/media/message-add.e196d4dbb862c0f768604ea526f4d2b9.svg";
export { ForwardRef as ReactComponent };